var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.state && _vm.items.length > 0
    ? _c("div", { staticClass: "ais-RefinementList" }, [
        _c(
          "h3",
          {
            staticClass: "h6 muted text-uppercase",
            staticStyle: { "letter-spacing": "var(--letter-spacing-2xl)" },
          },
          [_vm._v("\n    Categories\n  ")]
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "icons-facets-group-categories",
            staticStyle: {
              "--list-style-type": "none",
              "--padding-left": "0",
              "--margin-top": "0",
              "--margin-bottom": "var(--spacing-2xl)",
            },
          },
          _vm._l(_vm.items, function (item) {
            return _c(
              "li",
              {
                key: item.value,
                staticClass: "wrap-icons-facet-input margin-bottom-5xs",
              },
              [
                _c("input", {
                  staticClass: "with-icon",
                  attrs: {
                    id: `icons-category-${item.label}`,
                    type: "checkbox",
                    name: "categories",
                  },
                  domProps: { checked: item.isRefined },
                  on: {
                    click: function ($event) {
                      return _vm.selectCategory(item.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass:
                      "icons-facet icons-facet-input margin-0 flex-row size-sm flex-items-baseline",
                    staticStyle: {
                      padding: "var(--spacing-2xs) var(--spacing-sm)",
                      cursor: "pointer",
                      display: "flex !important",
                    },
                    attrs: { for: `icons-category-${item.label}` },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "icons-facet-affordance position-relative margin-right-sm",
                      },
                      [
                        _c("i", {
                          class: `fas fa-${_vm.categoryIcon(
                            item.value
                          )} fa-fw unchecked-icon`,
                        }),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticClass: "hover-icon",
                          attrs: {
                            icon: _vm.$v6.regular.faSquare,
                            "fixed-width": "",
                          },
                        }),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticClass: "checked-icon",
                          attrs: {
                            icon: _vm.$v6.solid.faSquareCheck,
                            "fixed-width": "",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "flex-grow": "1",
                          "flex-shrink": "1",
                          "flex-basis": "auto",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "sr-only" },
                          [
                            item.isRefined
                              ? [_vm._v("Showing ")]
                              : [_vm._v("Show ")],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-capitalize" }, [
                          _vm._v(_vm._s(_vm.categoryLabel(item.value))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v(" category icons"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "icons-facet-count margin-left-sm" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(item.count.toLocaleString()) +
                            "\n          "
                        ),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("matching results"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }